import manager from '@mailobj-browser/front/js/contracts/manager.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

const onClick = object(listener, {
  type: click,
  capture,
  passive,
  task: async (
    elt
  ) => {
    const { ownerDocument } = elt
    const { defaultView } = ownerDocument
    const { content } = one('template[data-info="logout"]', ownerDocument)
    const meta = one('meta', content.cloneNode(true))
    /* meta tag added in <head> does not work on FF <=78 */
    const contentAttr = meta.getAttribute('content')
    const url = contentAttr.split(';').at(-1)
    defaultView.location.href = url
  }
})

export default async (
  elt
) => {
  /* on définit le listener sur l'élément lui-même et non le parent */
  /* en effet ça ne peut pas fonctionner sur la home de kid */
  onClick.listen(elt)
}
